import { getDeviceId } from "@/utils";
import API from "./api";

export const signIn = async (payload) => {
  const deviceId = getDeviceId();
  const { data } = await API.post(`/v1/auth/login`, {
    ...payload,
    user_type: "user",
    device_id: deviceId,
  });
  return data;
};

export const forgotPassword = async (payload) => {
  const { data } = await API.post(`/v1/auth/forgot-password`, {
    ...payload,
    user_type: "user",
  });
  return data;
};

export const verifyOTP = async (payload) => {
  const { data, headers } = await API.post(`/v1/auth/verify-otp`, {
    ...payload,
    user_type: "user",
  });
  const hash = headers.get("hash-id-key");

  return { ...data, hash };
};

export const resetPassword = async (payload) => {
  const { password, hash } = payload;
  const { data } = await API.post(
    `/v1/auth/reset-password`,
    { password, user_type: "user" },
    {
      headers: {
        "hash-id-key": hash,
      },
    }
  );
  return data;
};

export const resendOTP = async (payload) => {
  const { data } = await API.post(`/v1/auth/resend-otp`, {
    ...payload,
    user_type: "user",
  });
  return data;
};

export const resendOTPSignUp = async (payload) => {
  const { data } = await API.post(`/v1/auth/resend-otp-signup`, payload);
  return data;
};

export const initiateSignUp = async (payload) => {
  const { data } = await API.post(`/v1/auth/verify-email`, {
    ...payload,
    user_type: "user",
  });
  return data;
};

export const verifySignUpOtp = async (payload) => {
  const { data, headers } = await API.post(`/v1/auth/verify-signup-otp`, {
    ...payload,
    user_type: "user",
  });
  const hash = headers.get("hash-id-key");

  return { ...data, hash };
};

export const signUp = async (payload) => {
  const deviceId = getDeviceId();
  const { hash, ...rest } = payload;
  const { data } = await API.post(
    `/v1/auth/signup`,
    { ...rest, device_id: deviceId },
    {
      headers: {
        "hash-id-key": hash,
      },
    }
  );
  return data;
};

export const fetchProfile = async () => {
  const { data } = await API.get(`/v1/auth/profile`, {
    params: { user_type: "user" },
  });
  return data.data;
};

export const setSecurePin = async (payload) => {
  const { data } = await API.patch("/v1/auth/secure-pin", {
    ...payload,
    user_type: "user",
  });
  return data;
};

export const studentSignUp = async (payload) => {
  const { data } = await API.post(`/v1/auth/student/signup`, payload);
  return data;
};

export const verifyAccount = async (payload) => {
  const { data } = await API.post(`/v1/auth/student/verify-account`, {
    ...payload,
    user_type: "user",
  });
  return data;
};

export const userLogout = async () => {
  const { data } = await API.post("v1/auth/logout", {});
  return data;
};

export const verifySignin = async (payload) => {
  const deviceId = getDeviceId();
  const { data } = await API.post("/v1/auth/verify-login", {
    ...payload,
    device_id: deviceId,
    user_type: "user",
  });
  return data;
};

export const contactSupport = async (payload) => {
  const { data } = await API.post(`/v1/auth/contact-support`, payload);
  return data;
};
